import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { AdvanceCategory, AdvanceType } from '../../events/CreateChargeEvent';
import { Checkbox, DateString, NonNegativeFloat, PositiveMonetaryValue } from '../fields';
import { InvestorSplit } from './RecordDrawDisbursementRow';

export const CreateAdvanceRow = z.object({
  loanId: LosId,
  interestRatePercent: NonNegativeFloat,
  advanceType: AdvanceType.optional(),
  recipient: z.string(),
  advanceDate: DateString,
  advancePrincipal: PositiveMonetaryValue,
  investorRemittanceSplit: InvestorSplit.optional(),
  isDeferred: Checkbox,
  isWaived: Checkbox,
  comment: z.string().optional(),
  advanceCategory: AdvanceCategory.optional(),
});
export type CreateAdvanceRow = z.infer<typeof CreateAdvanceRow>;

export const CREATE_ADVANCE_ROW_REQUIRED_FIELDS = Object.keys(CreateAdvanceRow.shape).filter(
  (key) => !CreateAdvanceRow.shape[key as keyof typeof CreateAdvanceRow.shape].isOptional(),
);
